class InspirationNavigationController {
    constructor($state) {
        this.$state = $state;
    }

    isOpen(category) {
        return this.$state.includes('shop.inspiration.parent', { parent: category.UrlPart });
    }
}

const inspirationNavigationComponentDefinition = {
    bindings: {
        menuItems: '=',
    },
    controller: ['$state', InspirationNavigationController],
    template: require('./inspiration-navigation.component.html').trim(),
};

module.exports = {
    InspirationNavigationController,
    inspirationNavigationComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/inspiration/navigation/inspiration-navigation.component.js